import React, { useState } from 'react';
import HeroSection from './components/HeroSection';
import ImageGallery from './components/ImageGallery';
import ImageViewer from './components/ImageViewer';
import { images } from './data/images';

function App() {
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  const openImage = (index) => {
    setSelectedImageIndex(index);
  };

  const closeImage = () => {
    setSelectedImageIndex(null);
  };

  const navigateImage = (direction) => {
    if (selectedImageIndex === null) return;
    
    if (direction === 'next') {
      setSelectedImageIndex((selectedImageIndex + 1) % images.length);
    } else {
      setSelectedImageIndex((selectedImageIndex - 1 + images.length) % images.length);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 via-white to-amber-50">
      <HeroSection images={images} />
      <ImageGallery images={images} onImageClick={openImage} />
      
      {selectedImageIndex !== null && (
        <ImageViewer
          image={images[selectedImageIndex]}
          onClose={closeImage}
          onNavigate={navigateImage}
        />
      )}
    </div>
  );
}

export default App;

